/**
 * Perform copy and paste operations on the system clipboard.
 *
 * @experimental
 * @public
 * @packageDocumentation
 */
import { invoke } from "./invoke.js";
/**
 * Reads the text from the clipboard.
 * @public
 */
export async function readText(...args) {
    return await invoke({
        namespace: "clipboard",
        method: "readText",
        args,
    });
}
/**
 * Writes the `text` into the clipboard as plain text.
 * @public
 */
export async function writeText(...args) {
    return await invoke({
        namespace: "clipboard",
        method: "writeText",
        args,
    });
}
/**
 * Reads the HTML from the clipboard.
 * @public
 */
export async function readHTML(...args) {
    return await invoke({
        namespace: "clipboard",
        method: "readHTML",
        args,
    });
}
/**
 * Writes the `text` into the clipboard as HTML..
 * @public
 */
export async function writeHTML(...args) {
    return await invoke({
        namespace: "clipboard",
        method: "writeHTML",
        args,
    });
}
/**
 * Reads the image from the clipboard.
 * @public
 */
export async function readImage(...args) {
    return await invoke({
        namespace: "clipboard",
        method: "readImage",
        args,
    });
}
/**
 * Writes the `image` into the clipboard as an image.
 * @public
 */
export async function writeImage(...args) {
    return await invoke({
        namespace: "clipboard",
        method: "writeImage",
        args,
    });
}
/**
 * Reads the RTF from the clipboard.
 * @public
 */
export async function readRTF(...args) {
    return await invoke({
        namespace: "clipboard",
        method: "readRTF",
        args,
    });
}
/**
 * Writes the `text` into the clipboard as RTF.
 * @public
 */
export async function writeRTF(...args) {
    return await invoke({
        namespace: "clipboard",
        method: "writeRTF",
        args,
    });
}
/**
 * Reads a bookmark from the clipboard.
 * @public
 */
export async function readBookmark(...args) {
    return await invoke({
        namespace: "clipboard",
        method: "readBookmark",
        args,
    });
}
/**
 * Writes the `title` (macOS only) and `url` into the clipboard as a bookmark.
 * @public
 */
export async function writeBookmark(...args) {
    return await invoke({
        namespace: "clipboard",
        method: "writeBookmark",
        args,
    });
}
/**
 * Clears the clipboard content.
 * @public
 */
export async function clear(...args) {
    return await invoke({
        namespace: "clipboard",
        method: "clear",
        args,
    });
}
/**
 * Supported formats for the clipboard.
 * @public
 */
export async function supportedFormats(...args) {
    return await invoke({
        namespace: "clipboard",
        method: "availableFormats",
        args,
    });
}
